
// GATED
(function () {
  var accessibe_script_loaded = false;

  function loadAccessibe() {
    if (accessibe_script_loaded) return;
    accessibe_script_loaded = true;

    var accessibe_script = document.createElement('script');
    var script_parent = document.querySelector('head') || document.body;

    accessibe_script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    accessibe_script.defer = true;

    accessibe_script.onload = function () {
      var init_attempts = 0;

      var wait_for_acsb = setInterval(function () {
        var custom_trigger = document.querySelector('.acc__link');

        if (++init_attempts > 100) {
          clearInterval(wait_for_acsb);
          return;
        }

        if (!custom_trigger || typeof acsbJS !== 'object' || typeof acsbJS.init !== 'function') return;
        clearInterval(wait_for_acsb);

        acsbJS.init({
          statementLink: 'https://thebeast.com/pages/accessibility',
          hideTrigger: true,
          disableBgProcess: false,
          language: 'en',
          position: 'left',
          leadColor: '#121212',
          triggerColor: '#121212',
          triggerRadius: '50%',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerIcon: 'people',
          triggerSize: 'medium',
          triggerOffsetX: 20,
          triggerOffsetY: 20,
          mobile: {
            triggerSize: 'small',
            triggerPositionX: 'right',
            triggerPositionY: 'bottom',
            triggerOffsetX: 10,
            triggerOffsetY: 10,
            triggerRadius: '50%'
          }
        });

        var trigger_attempts = 0;

        var wait_for_real_trigger = setInterval(function () {
          var real_trigger = document.querySelector('.acsb-trigger');

          if (++trigger_attempts > 100) {
            clearInterval(wait_for_real_trigger);
            return;
          }
          if (!real_trigger) return;

          clearInterval(wait_for_real_trigger);
          real_trigger.style.display = 'none';
          custom_trigger.addEventListener('click', function (event) {
            event.preventDefault();
            real_trigger.click();
          });
        }, 100);
      }, 100);
    };

    script_parent.appendChild(accessibe_script);
  }

  function consentAllowsAccessibe() {
    var privacy_api = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy_api) return false;
    return privacy_api.preferencesProcessingAllowed();
  }

  // Consent given later in the session (banner interaction)
  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail.preferencesAllowed) loadAccessibe();
  });

  // Consent already on record (or region requires no banner)
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (consentAllowsAccessibe()) loadAccessibe();
      }
    );
  }
})();